/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExtensionConfig} from '../api'

 export const useQueryGetExtensionConfig = createReactQueryHook('getExtensionConfig', getExtensionConfig)
